import { platformHandler } from '../platforms/PlatformHandler'
const request = require('superagent');

/**
 * Hit the companylookup endpoint with the proper query.
 * Return a promise that resolves with the response.
 */
export function requestPostSail( url, payload, callback ) {
  if( !platformHandler.isElectron){
    require('es6-promise').polyfill();
    require('isomorphic-fetch');
  }

  request
    .post(url)
    .send(payload)
    // .set('accept', 'json')
    .end((err, res) => {
      if(err) {
        console.error('Ooops!! Houston, tenemos problemas!! nuestros servidores están caidos :(', err);
        return callback(err);
      }
      if(res && res.body) {
        callback(res.body);
      } else {
        console.error('Ooops!! Houston, tenemos problemas!! nuestros servidores no responden :(', err);
        callback({});
      }
    });

}

export function getLocalJSON( url, callback, isElectron, callbackError ) {
  if (isElectron) {
    let fs = window.require('fs');

    let pathJSON = url;
    var os = window.require('os');
    //if( os.platform() == "darwin"){

    if( process.env.REACT_APP_PRODUCTION===true || process.env.REACT_APP_PRODUCTION==="true" ) {
      var path = window.require('path');
      pathJSON = path.join(window.__dirname, url);
    }
    
      console.log('pathJSON', pathJSON)
    //}

    fs.readFile(pathJSON, "utf8", (error, data) => {
        if (error) {
          console.error('Ooops!! Houston, tenemos problemas!! no se pudo obtener json :(', error);
          if( callbackError ){
            callbackError(error);
          }
        } else {
          callback( JSON.parse(data));
        }
      })
  }
  else{
    if( !platformHandler.isElectron){
      require('es6-promise').polyfill();
      require('isomorphic-fetch');
    }

    request.get(url).end((err, res) => {
      if(err) {
        console.log('Error en request',err);
        if( callbackError ){
          return callbackError(err);
        }
        else {
          console.log('Error with no callback',err)          
        }
      }
      if(res && res.body) {
        callback(res.body);
      } else {
         if( callbackError ){
          return callbackError({});
        }
        else {
          console.log('Error with no callback',res)          
        }
      }
    });
  }
  
  
}



// WEBPACK FOOTER //
// ./src/containers/utils/requester.js